import { Controller } from "@hotwired/stimulus";

// Handles clicks on tracked links, logs the interaction, and conditionally navigates.
// Requires data values: url, actionItem, tnId
// We use this tracking method for links that are inside TURBO FRAMES
// Turbo frame links have issues with the default tracking method using otto-custom.js
export default class extends Controller {
  static values = {
    url: String, // RESTORED - The destination URL for navigation
    actionItem: String, // The identifier for the action being logged
    tnId: String | Number, // The Tier Notification ID for logging
  };

  connect() {
    console.log(
      `[TrackedLink] Controller connected for action: ${this.actionItemValue}`,
    );
  }

  async handleClick(event) {
    event.preventDefault();
    console.log(
      `[TrackedLink] Click handled for action: ${this.actionItemValue}`,
    );

    const lenderClientId = document.body.dataset.lenderClientId;

    // --- Log Interaction ---
    // Use this.urlValue if available, otherwise current page
    const destinationForLog =
      this.hasUrlValue && this.urlValue.length > 0
        ? this.urlValue
        : window.location.href;
    console.log(`[TrackedLink] Logging data:`, {
      action_item: this.actionItemValue,
      destination_url: destinationForLog,
      tn_id: this.tnIdValue,
      lender_client_id: lenderClientId,
    });

    try {
      const response = await fetch("/user_interactions/log_action", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
            ?.content,
        },
        body: JSON.stringify({
          destination_url: destinationForLog,
          action_item: this.actionItemValue,
          tn_id: this.tnIdValue,
          lender_client_id: lenderClientId,
        }),
      });
      if (!response.ok) {
        console.error(
          `[TrackedLink] Error logging interaction: Status ${response.status}`,
        );
      } else {
        console.log("[TrackedLink] Interaction logged successfully.");
      }
    } catch (error) {
      console.error("[TrackedLink] Fetch error logging interaction:", error);
    }

    // --- RESTORED Conditional Navigation ---
    const isTrackerOpen =
      document.body.dataset.notificationTrackerOpen === "true";
    console.log(
      `[TrackedLink] Post-log check - isTrackerOpen: ${isTrackerOpen}, urlValue: ${this.urlValue}`,
    );

    if (!isTrackerOpen && this.hasUrlValue && this.urlValue.length > 0) {
      console.log(
        `[TrackedLink] Tracker closed, navigating to: ${this.urlValue}`,
      );
      window.location.href = this.urlValue;
    } else {
      console.log(
        "[TrackedLink] Tracker open or no URL value, navigation prevented.",
      );
    }
  }
}
